angular.module('unergie.main')
.directive('uploader', ($rootScope, DataAccessSearch, ReferencesService, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/uploader/uploader.html',
        scope: {
            instance: '=',
            title: '=',
            accept: '=',
            showQueue: '@',
            btnClass: '=',
            tooltip: '=',
            processing: '=',
        },
    })
)
